// extracted by mini-css-extract-plugin
export default {"page":"Reports_page__aVuDB","title":"Reports_title__jVZiC"};